/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_RejectedInputs */

const en_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const de_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const fr_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé`)
};

const es_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado`)
};

const it_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutata`)
};

const nl_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen`)
};

const pl_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucono`)
};

const fi_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylätty`)
};

const da_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist`)
};

const sv_applications_status_rejected = /** @type {(inputs: Applications_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisad`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Applications_Status_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_rejected = /** @type {((inputs?: Applications_Status_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_rejected(inputs)
	if (locale === "fr") return fr_applications_status_rejected(inputs)
	if (locale === "es") return es_applications_status_rejected(inputs)
	if (locale === "it") return it_applications_status_rejected(inputs)
	if (locale === "nl") return nl_applications_status_rejected(inputs)
	if (locale === "pl") return pl_applications_status_rejected(inputs)
	if (locale === "fi") return fi_applications_status_rejected(inputs)
	if (locale === "da") return da_applications_status_rejected(inputs)
	if (locale === "sv") return sv_applications_status_rejected(inputs)
	return en_applications_status_rejected(inputs)
});